import { setUpdatePending } from '@maat/store-error';
import { reloadForStaleChunk } from '@maat/components-errors';
import { buildInfo } from './buildInfo';

// Matches VersionWatcher's manifest; only sha is needed here.
interface VersionManifest {
    sha?: string;
}

/**
 * A bfcache restore resurrects an old build's DOM with NO HTTP fetch, so a user
 * returning via back/forward resumes a superseded build and crashes on its first
 * lazy load. On a persisted `pageshow` this re-checks /version.json and reloads
 * once. Window-level on purpose: it works even if the React tree had crashed.
 * Inert off-prod and when the check itself fails.
 */
export function installBfcacheVersionCheck(): void {
    if (!buildInfo.sha) return;

    window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        void fetch('/version.json', { cache: 'no-store' })
            .then((res) => (res.ok ? (res.json() as Promise<VersionManifest>) : null))
            .then((manifest) => {
                if (!manifest?.sha || manifest.sha === buildInfo.sha) return;
                // Latch first: even if the reload is suppressed or races, the
                // ErrorBoundary and UpdateMigrator know a newer build is live.
                setUpdatePending(manifest.sha);
                reloadForStaleChunk();
            })
            .catch(() => {});
    });
}
